import { activateOrganisation } from '@infuse/api/iam/organisation';
import { activateTenantOrganisation } from '@infuse/api/iam/tenant';
import { UserLevel } from '@infuse/iam/user/type';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { useGenericActivateOrganisation } from './generic/useGenericActivateOrganisation';

export const useActivateOrganisation = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.TENANT) {
    return useGenericActivateOrganisation({
      apiFn: activateTenantOrganisation,
      forcedParentId: user?.tenantId
    });
  }

  return useGenericActivateOrganisation({
    apiFn: activateOrganisation
  });
};
